import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import PageContainer from '../components/layout/PageContainer';
import whatsappIcon from '../assets/whatsapp.svg';
import instagramIcon from '../assets/instagram.svg';

const About = () => {
  const header = (
    <div className="sticky top-0 z-10 bg-background pt-2 pb-4 px-4 border-b border-white/10">
      <div className="flex items-center gap-4">
        <Link to="/" className="text-white">
          <ChevronLeftIcon className="h-6 w-6" />
        </Link>
        <h1 className="text-xl font-semibold text-white">
          Sobre
        </h1>
      </div>
    </div>
  );

  return (
    <PageContainer stickyHeader={header}>
      <div className="space-y-6">
        {/* Project Description */}
        <section className="bg-white/10 backdrop-blur-lg rounded-xl p-6">
          <div className="flex flex-col items-center mb-6">
            <img 
              src="/logo.png" 
              alt="DizQueTem" 
              className="w-full h-48 object-contain rounded-lg mb-4"
            />
            <h2 className="text-xl font-semibold text-white mb-2">
              Sobre o DizQueTem
            </h2>
            <p className="text-white/80 text-center">
              Conectando pessoas aos melhores estabelecimentos locais através de avaliações autênticas e informações detalhadas.
            </p>
          </div>

          <div className="flex gap-3">
            <a
              href={`https://wa.me/5582996681956?text=${encodeURIComponent('Olá, gostaria de saber como divulgar meu negócio no App DizQueTem')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 bg-green-500 hover:bg-green-600 text-white py-2 px-4 rounded-lg text-center transition-colors flex items-center justify-center gap-2"
            >
              <img src={whatsappIcon} alt="WhatsApp" className="h-5 w-5" />
              WhatsApp
            </a>
            <a
              href="https://instagram.com/dizquetem.smc"
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 bg-gradient-to-r from-[#833AB4] via-[#FD1D1D] to-[#F77737] hover:opacity-90 text-white py-2 px-4 rounded-lg text-center transition-colors flex items-center justify-center gap-2"
            >
              <img src={instagramIcon} alt="Instagram" className="h-5 w-5" />
              Instagram
            </a>
          </div>
        </section>

        {/* Features */}
        <section className="bg-white/10 backdrop-blur-lg rounded-xl p-6">
          <h2 className="text-xl font-semibold text-white mb-4">
            Nossos Diferenciais
          </h2>
          <div className="space-y-4">
            <div className="flex gap-3">
              <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0">
                <span className="text-primary text-sm font-medium">1</span>
              </div>
              <div>
                <h3 className="text-white font-medium mb-1">
                  Avaliações Autênticas
                </h3>
                <p className="text-white/60 text-sm">
                  Todas as avaliações são verificadas para garantir a autenticidade.
                </p>
              </div>
            </div>
            <div className="flex gap-3">
              <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0">
                <span className="text-primary text-sm font-medium">2</span>
              </div>
              <div>
                <h3 className="text-white font-medium mb-1">
                  Informações Detalhadas
                </h3>
                <p className="text-white/60 text-sm">
                  Horários, contatos e serviços disponíveis em cada estabelecimento.
                </p>
              </div>
            </div>
            <div className="flex gap-3">
              <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0">
                <span className="text-primary text-sm font-medium">3</span>
              </div>
              <div>
                <h3 className="text-white font-medium mb-1">
                  Comunidade Ativa
                </h3>
                <p className="text-white/60 text-sm">
                  Compartilhe suas experiências e descubra novos lugares.
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </PageContainer>
  );
};

export default About; 